import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-steel/30 bg-navy-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annv9w342d2m">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcqpu1ud1ag">The {totalBonuses} <span className="text-gold" data-id="element-21" data-mp="15q5j7wtsrhqe">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-steel/60 bg-navy-950 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jgir5z6ouwfq">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-steel/15 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="r07yxryznc6h" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-copper/50 bg-navy-900 text-copper" data-id="element-24" data-mp="2jixrurt0d50u">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2oitsqi6esgc6" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-26" data-mp="1qvbnvifvbydg">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-27" data-mp="1vrik2jigpvi7">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-28" data-mp="20qde6hlvr6hm">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-steel-light" data-id="element-29" data-mp="25s2mvqlmr82j">{bonus.description}</p>
                </div>
                <div className="shrink-0 text-right" data-id="element-30" data-mp="3c8wiusqrjc85">
                  <p className="whitespace-nowrap text-sm font-semibold text-steel-light line-through decoration-gold decoration-2" data-id="element-31" data-mp="3h4lo9cpgrncd">{bonusValue}</p>
                  <p className="mt-0.5 text-lg font-extrabold text-gold" data-id="element-32" data-mp="1h58bfb6jy5gt">FREE</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-navy-950 px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-33" data-mp="1q3250ecxml0a">
          <div data-id="element-34" data-mp="ydyx8olu6siw">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-steel-light" data-id="element-35" data-mp="ydfex6s9y24c">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-steel-light line-through decoration-gold decoration-2" data-id="element-36" data-mp="tbzthdm6ptlf">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-37" data-mp="12cegqiiplirk">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-steel-light" data-id="element-38" data-mp="eoepziledscz">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-gold" data-id="element-39" data-mp="ao4mqdozpg1t">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="id33ki2er6w" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}